<template>
  <div class="app-main-inner" style="height:100%;width: 100%;background-color: #F5F7FA">
    <div class="app-main-inner-row">
      <div class="triggers">
        <template v-if="!isEdit">
          <el-button type="primary" @click="toAddRole">{{ $t('CargoMsg.Cargo_New') }}</el-button>
          <el-button type="primary" :disabled="oneRole.systemDefined" @click="toEditRole">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
          <el-button type="danger" :disabled="oneRole.systemDefined" @click="toDelRole">{{ $t('CargoMsg.Cargo_OrderDelete') }}</el-button>
          <el-button type="primary" @click="toBatchAddPermission2Role">{{ $t('CargoMsg.Cargo_BatchAddRolePermissions') }}</el-button>
          <el-button type="primary" @click="roleGrid.gridApi.expandAll()">{{ $t('queryJob.expandAll') }}</el-button>
          <el-button type="primary" @click="onCollapseRoles">{{ $t('queryJob.putItAllAway') }}</el-button>
          <el-button type="primary" @click="popNoCurrentRoleUser">{{ $t('CargoMsg.Cargo_AddUser') }}</el-button>
          <el-button type="danger" @click="toDelUser">{{ $t('CargoMsg.Cargo_RemoveUser') }}</el-button>
        </template>
      </div>
    </div>
    <cargo-left-right-resize
      ref="cargoLeftRightResize"
      :left-style="{flex:'none','max-width':'700px',width:cargoLfResizeCacheValue.leftW}"
      :right-style="{'overflow': 'hidden',width:cargoLfResizeCacheValue.rightW}"
      style="min-height:100%"
      @onSize="cargoLfResizeCacheValue = $event;"
    >
      <template slot="left">
        <!-- 当前角色列表 -->
        <div class="user-role-manage" style="min-width:300px;height:100%;padding: 8px 16px">
          <div style="height: 40px">{{ $t('CargoMsg.Cargo_CurrentUserRole') }}</div>
          <cargo-ag-grid
            config-module="20220813"
            :show-side-bar="false"
            :column-defs="userOfRoleGrid.columnDefs"
            :row-data="userOfRoleGrid.rowData"
            :grid-options="userOfRoleGrid.gridOptions"
            style="width: 100%;flex-grow:1;height: 95%"
          />
        </div>
      </template>
      <template slot="right">
        <div class="app-main-inner-row" style="height: 100%;display: flex;gap: 10px">
          <div style="width:49%;min-width:490px;display: flex;flex-direction: column">
            <div style="margin-bottom: 5px;">
              <el-form :inline="true" label-width="100px" label-position="left" @submit.native.prevent>
                <div class="el-form-item-wrapper">
                  <el-form-item :label="$t('CargoMsg.Cargo_RoleName')">
                    <el-input v-model="oneRole.name" style="min-width: 160px;width: 100%" :disabled="!isEdit" size="mini" placeholder="" />
                  </el-form-item>
                  <el-form-item>
                    <el-input v-model="roleGridLikeName" :placeholder="this.$t('Message.RetrievalOfAssignedPermissions')" style="min-width: 160px;width: 100%" @input="toFilterNoRoleGrid" />
                  </el-form-item>
                </div>
              </el-form>
            </div>
            <div style="display:flex;flex-grow: 1">
              <cargo-ag-grid
                :show-side-bar="false"
                :check-main-record="false"
                :deselect-sub-record="true"
                :deselect-main-record="false"
                :grid-options="roleGrid.gridOptions"
                :column-defs="roleGrid.columnDefs"
                :row-data="roleGrid.rowData"
                style="width:100%; height: 100%;"
                @gridReady="params=>{roleGrid.gridApi=params.api}"
              />
            </div>
            <div>
              <el-input v-model="oneRole.description" :disabled="!isEdit" type="textarea" rows="3" resize="none" />
            </div>
            <div style="display: flex;justify-content: space-between;margin-top: 5px;">
              <div>
                <el-select v-model="oneRole.roleScope" style="width: 100px;" :disabled="!isEdit" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')">
                  <el-option :label="$t('CargoMsg.Cargo_Personal2')" value="IND" />
                  <el-option :label="$t('CargoMsg.Cargo_DepartmentGroups')" value="DPT" />
                </el-select>
              </div>
              <div>
                <template v-if="isEdit">
                  <el-button type="primary" @click="roleGrid.gridApi.expandAll()">{{ $t('queryJob.expandAll') }}</el-button>
                  <el-button type="primary" @click="onCollapseRoles">{{ $t('queryJob.putItAllAway') }}</el-button>
                  <el-button type="primary" @click="toSave">{{ $t('CargoMsg.Cargo_UpdatePermissionGroups') }}</el-button>
                  <el-button type="primary" @click="toCancelSave">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
                  <el-button type="danger" :disabled="!isEdit" @click="toDelPermission4Role">{{ $t('CargoMsg.Cargo_GreaterRemove') }}</el-button>
                </template>
              </div>
            </div>
          </div>
          <div style="width:49%;min-width:490px;display: flex;flex-direction: column">
            <div style="margin-bottom: 10px;">
              <el-input v-model="privilegeLikeName" style="width: 200px;" @input="toFilterNoRole" />
            </div>
            <div style="display:flex;flex-grow: 1">
              <cargo-ag-grid
                :show-side-bar="false"
                :check-main-record="false"
                :deselect-sub-record="true"
                :deselect-main-record="false"
                :grid-options="privilegeGrid.gridOptions"
                :column-defs="privilegeGrid.columnDefs"
                :row-data="privilegeGrid.rowData"
                style="width:100%;"
              />
            </div>
            <div style="margin-top: 5px;">
              <el-button type="primary" :disabled="!isEdit" @click="toAddPermission2Role">{{ $t('CargoMsg.Cargo_LessAdd') }}</el-button>
            </div>
          </div>
        </div>
      </template>

    </cargo-left-right-resize>
    <!-- 添加用户 -->
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="userOfNoCurrentRoleGrid.isShow" :title="$t('SystemMaintenance.AddRoleUser')" width="800px;" @close="userOfNoCurrentRoleGrid.searchLikeName=''">
      <div class="app-main-inner-row" style="padding-bottom: 5px;">
        <div class="filters">
          <el-form :inline="true" label-width="50px" label-position="left" @submit.native.prevent>
            <div class="el-form-item-wrapper">
              <el-form-item :label="$t('CargoMsg.Cargo_Search')">
                <el-input v-model="userOfNoCurrentRoleGrid.searchLikeName" style="width: 260px" size="mini" placeholder="" @input="toFilterNoCurrentRoleUser" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </div>
      <div class="app-main-inner-row row-grid-dialog">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="userOfNoCurrentRoleGrid.gridOptions"
          :column-defs="userOfNoCurrentRoleGrid.columnDefs"
          :row-data="userOfNoCurrentRoleGrid.rowData"
          style="width:100%;"
        />
      </div>
      <div slot="footer">
        <el-button type="primary" size="mini" @click="toSaveNoCurrentRoleUser">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button size="mini" @click="userOfNoCurrentRoleGrid.isShow=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { getRolePrivilegeTree, getTenantPrivilegeTree } from '@/api/privilege'
import { batchDelRole, saveRole, getRoleByUuid, batchAddRolePermission } from '@/api/role'
import { getGridSelected, getGridSelectedIds } from '@/utils/agGrid'
import { getLoading } from '@/utils/utilBaseElement'
import { addUser2Role, delUser2Role, getUserListByRoleUuid, getUserListForRole } from '@/api/user'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'RoleTab',
  components: {
    cargoLeftRightResize

  },
  props: {
    sourceType: {
      type: String,
      default: 'clickTree' // 进入该页面的来源，点击树or officeTab过来的
    },
    treeNode: {
      type: Object,
      required: true
    }
  },
  data() {
    const isZh = this.$store.getters.language === 'zh'
    return {
      isZh,
      loading: false,
      isEdit: false,
      constant: {
        sourceType: {
          click: 'clickTree',
          dept: 'deptTab'
        }
      },
      initOneRole: {
        acrossTenant: false,
        clientRefCode: '',
        createdBy: 0,
        dateCreated: null,
        dateModified: null,
        description: '',
        dirty: false,
        extendedData: '',
        modifiedBy: 0,
        name: '',
        privileges: '',
        roleId: 0,
        roleScope: 'IND',
        systemDefined: false,
        tenantId: 0,
        uuid: '',
        version: 0
      },
      oneRole: {
        ...this.initOneRole
      },
      roleGridLikeName: '',
      roleRequest: { // 请求数据实体
        uuid: '',
        name: '',
        roleId: 0,
        department: '',
        systemDefined: false,
        description: '',
        roleScope: '',
        specialRole: false,
        addPrivilegeUuidList: [],
        removePrivilegeUuidList: []
      },
      roleGrid: {
        oldPrivilegeUuidList: [], // 初始化加载的 权限集合
        currentChooseRowPath: [],
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_PleaseSelect'),
            field: 'chineseName',
            width: 150,
            hide: true
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PermissionCategory'),
            field: 'category',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_PermissionType'),
            field: 'shape',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_PermissionPoint'),
            field: 'point',
            width: 150
          }
        ],
        rowData: null,
        initRowData: null,
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 5,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_PermissionName'),
            field: 'chineseName',
            width: 300,
            tooltipValueGetter: (params) => {
              return ''
            },
            cellStyle: params => {
              if (!params.data.haveChild) {
                return {
                  paddingLeft: `23px !important;`
                }
              }
            },
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (!params.data) {
                  return ''
                }
                return isZh ? params.data.chineseName : (params.data.englishName || params.data.chineseName)
              },
              checkbox: true
            }
          }
        },
        gridApi: null,
        expandStatus: new Map()
      },
      privilegeLikeName: '',
      privilegeGrid: {
        currentChooseRowPath: [],
        columnDefs: [
          {
            headerName: this.$t('CargoMsg.Cargo_PermissionCategory'),
            field: 'category',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_PermissionType'),
            field: 'shape',
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_PermissionPoint'),
            field: 'point',
            width: 150
          }
        ],
        rowData: null,
        initRowData: null,
        gridOptions: {
          rowSelection: 'multiple',
          groupDefaultExpanded: 0,
          suppressRowClickSelection: true,
          treeData: true,
          getDataPath: (data) => {
            return data.path.split(',')
          },
          onRowSelected(event) {
            // this.onPrivilegeSelectionChanged(event)
          },
          autoGroupColumnDef: {
            headerName: this.$t('CargoMsg.Cargo_PermissionName'),
            field: 'chineseName',
            width: 300,
            headerCheckboxSelection: true,
            tooltipValueGetter: (params) => {
              return ''
            },
            cellRendererParams: {
              suppressCount: true,
              suppressDoubleClickExpand: true,
              innerRenderer: (params) => {
                if (!params.data) {
                  return ''
                }
                return isZh ? params.data.chineseName : (params.data.englishName || params.data.chineseName)
              },
              checkbox: true
            },
            cellStyle: params => {
              if (!params.data.haveChild) {
                return {
                  paddingLeft: `23px !important;`
                }
              }
            }
          }
        }
      },
      parentPrivilegeUuidMap: new Map(), // 存放父节点的uuid(数据库中只有子节点，没有父节点)
      // 拥有该角色的用户
      userOfRoleGrid: {
        isShow: false,
        initRowData: [],
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        gridOptions: {},
        sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false }
      },
      // 未分配当前角色用户
      userOfNoCurrentRoleGrid: {
        isShow: false,
        searchLikeName: '',
        columnDefs: [],
        rowData: [],
        initRowData: [],
        gridOptions: {}
      }
    }
  },
  computed: {
    cargoLfResizeCacheValue: {
      get() {
        return LocalStorageUtilsNew.getConfiguration('roleTabCResizeCache') || {}
      },
      set(newValue) {
        LocalStorageUtilsNew.setConfiguration('roleTabCResizeCache', newValue)
      }
    }
  },
  watch: {
    treeNode() {
      if (this.sourceType === this.constant.sourceType.click) {
        this.parentPrivilegeUuidMap.clear()
        this.fetchPageData()
      }
    }
  },
  beforeMount() {
    this.oneRole = { ...this.initOneRole }
    this.parentPrivilegeUuidMap.clear()

    // 拥有该角色的用户
    this.userOfRoleGrid.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
        field: 'chineseName',
        width: 240
      }, {
        headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
        field: 'englishName',
        width: 100
      },
      { headerName: this.$t('CargoMsg.Cargo_isActive'),
        field: 'active',
        width: 100,
        cellRenderer: params => ColumnUtils.booleanColumnLabelFunc(params.value)
      }]
    this.userOfRoleGrid.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
      suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
      defaultColDef: {
        resizable: true,
        filter: true
      }
    }

    // 没被分配当前角色的用户
    this.userOfNoCurrentRoleGrid.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      {
        headerName: this.$t('CargoMsg.Cargo_LoginName'),
        field: 'login',
        width: 240
      },
      {
        headerName: this.$t('CargoMsg.Cargo_ChineseNamed'),
        field: 'chineseName',
        width: 100
      }, {
        headerName: this.$t('CargoMsg.Cargo_EnglishNamed'),
        field: 'englishName',
        width: 100
      }, {
        headerName: this.$t('CargoMsg.Cargo_email'),
        field: 'email',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Tel'),
        field: 'phone',
        width: 120
      }, {
        headerName: this.$t('CargoMsg.Cargo_Fax'),
        field: 'fax',
        width: 100
      }]
    this.userOfNoCurrentRoleGrid.gridOptions = {
      rowSelection: 'multiple',
      suppressCellSelection: true,
      defaultColDef: {
        resizable: true,
        filter: true
      }
    }
  },
  mounted() {
    if (this.sourceType === this.constant.sourceType.click) {
      this.editHandler(false)
    }
    if (this.sourceType === this.constant.sourceType.dept) {
      this.editHandler(true)
    }
    this.fetchPageData(true)
  },
  methods: {
    initData() {
      this.editHandler(false)
    },
    async fetchPageData(isLoadPrivilege) {
      // 从部门新增角色场景
      if (this.treeNode && this.treeNode.typeDesc === 'dept') {
        await getTenantPrivilegeTree().then(res => {
          this.privilegeGrid.rowData = res.data
          this.privilegeGrid.initRowData = res.data
          const department = this.oneRole.department
          this.oneRole = { ...this.initOneRole, department }
          this.roleGrid.oldPrivilegeUuidList = []
          this.roleGrid.rowData = []
          this.roleGrid.initRowData = []
          this.roleGrid.currentChooseRowPath = []
        })
      } else {
        this.getUserListByRole(this.treeNode.uuid)
        const func = [getRolePrivilegeTree(this.treeNode.uuid), getRoleByUuid(this.treeNode.uuid)]
        if (isLoadPrivilege) {
          func.push(getTenantPrivilegeTree())
        }
        await Promise.all(func).then(res => {
          // 右侧全部权限 仅首次加载
          if (isLoadPrivilege) {
            this.privilegeGrid.rowData = res[2].data
            this.privilegeGrid.initRowData = res[2].data
          }
          // 当前选中角色信息
          this.oneRole = res[1].data
          // 角色关联权限信息
          const roleData = res[0].data
          const list = []
          // 过滤出数据库中有子节点，但是没有父节点的数据，并把父节点记录下来
          if (roleData && roleData.length > 0) {
            // 子节点需要带出 父节点
            for (const data of roleData) {
              if (data.parentUuid) {
                this.findParentPrivilege(data, roleData)
              }
            }
          }
          // 子节点需要带出 父节点
          if (this.privilegeGrid.initRowData) {
            for (const data of roleData) {
              // 校验自身是否有效
              const selfData = this.privilegeGrid.initRowData.find(p => p.uuid === data.uuid)
              if (selfData) {
                list.push(selfData)
              }
              this.getPData(selfData, list)
            }
          }
          const row = this.removeDuplicates(list)
          this.roleGrid.rowData = row
          this.roleGrid.initRowData = row
          this.roleGrid.oldPrivilegeUuidList = row.map(item => {
            return item.uuid
          })
          this.toFilterNoRoleGrid()
        }).catch((e) => {
          this.$message.error(this.$t('SystemMaintenance.Error') + ' ' + e)
        })
      }
    },
    getPData(data, list) {
      if (data.parentUuid) {
        const pData = this.privilegeGrid.initRowData.find(p => p.uuid === data.parentUuid)
        if (pData) {
          list.push(pData)
          this.getPData(pData, list)
        }
      }
      return list
    },
    // 去除重复
    removeDuplicates(list) {
      const nowList = []
      for (const d of list) {
        const pData = nowList.find(p => p.uuid === d.uuid)
        if (!pData) {
          nowList.push(d)
        }
      }
      return nowList
    },
    onRoleSelectionChanged(event) {
      this.onSelectionChanged(event, this.roleGrid)
    },
    onPrivilegeSelectionChanged(event) {
      this.onSelectionChanged(event, this.privilegeGrid)
    },
    onSelectionChanged(event, grid) {
      console.log('event', event)
      console.log('event.node', event.node.isSelected())
      const node = event.node
      const data = event.data
      if ((!node.isSelected()) || data && !grid.currentChooseRowPath.includes(data.uuid)) {
        if (node.isSelected()) {
          grid.currentChooseRowPath = data.path.slice(0, -1) // 移除本身
          node.selectChildNodes(true)
          this.upLoopChoose(node)
        } else {
          grid.currentChooseRowPath = []
          node.selectChildNodes(false)
        }
        console.log('event.node.parent.group', event.node.parent.group)
      }
    },
    // 向上循环选中
    upLoopChoose(node) {
      if (node && !node.group) { // 不是grid顶级，就向上传递选择
        node.setSelected(true)
        this.upLoopChoose(node.parent)
      } else {
        console.log('终止')
        return
      }
    },
    toAddRole() {
      const department = this.oneRole.department
      this.oneRole = { ...this.initOneRole, department }
      this.editHandler(true)
      this.roleGrid.oldPrivilegeUuidList = []
      this.roleGrid.rowData = []
      this.roleGrid.initRowData = []
      this.roleGrid.currentChooseRowPath = []
    },
    async toEditRole() {
      this.recordRoleExpandStatus()
      await this.fetchPageData(false)
      this.editHandler(true)
      this.$nextTick(() => {
        this.recoverRoleExpandStatus()
      })
    },
    // 记录角色展开状态
    recordRoleExpandStatus() {
      this.roleGrid.expandStatus.clear()
      const nodes = this.roleGrid.gridApi.rowModel.rootNode.allLeafChildren
      for (const item of nodes) {
        this.roleGrid.expandStatus.set(item.data.uuid, item.expanded)
      }
    },
    // 恢复角色展开状态
    recoverRoleExpandStatus() {
      const nodes = this.roleGrid.gridApi.rowModel.rootNode.allLeafChildren
      for (const item of nodes) {
        const val = this.roleGrid.expandStatus.get(item.data.uuid)
        if (typeof val === 'undefined') {
          continue
        }
        item.expanded = val
      }
      this.roleGrid.gridApi.onGroupExpandedOrCollapsed()
    },
    toDelRole() {
      const roles = getGridSelected(this.$parent.$parent.officeDeptTree.gridOptions)
      const roleList = []
      for (const r of roles) {
        if (r.typeDesc === 'role') {
          roleList.push(r)
        }
      }
      if (roleList && roleList.length > 0) {
        this.$confirm(this.$t('SystemMaintenance.AreDeleteTheCurrentlyRoles') + roleList.length + this.$t('SystemMaintenance.NXRoles'), this.$t('SystemMaintenance.Prompt'), {
          confirmButtonText: this.$t('SystemMaintenance.OK'),
          cancelButtonText: this.$t('SystemMaintenance.Cancel'),
          type: 'warning'
        }).then(() => {
          this.loading = getLoading()
          batchDelRole(roleList).then(res => {
            this.$emit('refreshTree', roleList[0].parentUuid)
          }).finally((e) => {
            this.loading.close()
          })
        })
      } else {
        this.$message.warning(this.$t('SystemMaintenance.PleaseOrMoreRolesDelete'))
      }
    },
    onCollapseRoles() {
      const nodes = this.roleGrid.gridApi.rowModel.rowsToDisplay
      for (const item of nodes) {
        item.expanded = false
      }
      this.roleGrid.gridApi.onGroupExpandedOrCollapsed()
    },
    async toBatchAddPermission2Role() {
      const roles = getGridSelected(this.$parent.$parent.officeDeptTree.gridOptions)
      const privileges = getGridSelected(this.privilegeGrid.gridOptions)
      const roleUuids = []
      for (const r of roles) {
        if (r.typeDesc === 'role') {
          roleUuids.push(r.uuid)
        }
      }
      if (roleUuids.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseOneOrMoreRoles'))
        return
      }
      const privilegeUuids = []
      const list = []
      // 子节点需要带出 父节点
      for (const data of privileges) {
        // 校验自身是否有效
        const selfData = this.privilegeGrid.initRowData.find(p => p.uuid === data.uuid)
        if (selfData) {
          list.push(selfData)
        }
        this.getPData(selfData, list)
      }
      for (const p of list) {
        if (!privilegeUuids.includes(p.uuid)) {
          privilegeUuids.push(p.uuid)
        }
      }
      if (privilegeUuids.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseOneOrMorePermissions'))
        return
      }
      this.recordRoleExpandStatus()
      this.loading = getLoading()
      batchAddRolePermission({ roleUuids, privilegeUuids }).then(async res => {
        this.$message.success(this.$t('SystemMaintenance.BatchAddSuccessfully'))
        await this.fetchPageData()
        this.recoverRoleExpandStatus()
      }).finally((e) => {
        this.loading.close()
      })
    },
    toCheckForm() {
      let error = ''
      if (!this.oneRole.name) {
        error = this.$t('SystemMaintenance.PleaseEnterTheRoleName')
      }
      if (error) {
        this.$message.error(error)
        return false
      }
      return true
    },
    toDelPermission4Role() {
      const chooseRows = this.roleGrid.gridOptions.api.getSelectedRows()
      if (chooseRows.length < 1) {
        this.$message.error(this.$t('SystemMaintenance.PleaseSelectDataFirst'))
      }
      this.recordRoleExpandStatus()
      const chooseRowUuids = chooseRows.map(item => item.uuid)
      this.roleGrid.rowData = this.roleGrid.rowData.filter(item => {
        return !chooseRowUuids.includes(item.uuid)
      })
      this.roleGrid.initRowData = this.roleGrid.initRowData.filter(item => {
        return !chooseRowUuids.includes(item.uuid)
      })
      this.$nextTick(() => {
        this.recoverRoleExpandStatus()
      })
    },
    toAddPermission2Role() {
      this.recordRoleExpandStatus()
      const chooseRows = this.privilegeGrid.gridOptions.api.getSelectedRows()
      let list = []
      // 子节点需要带出 父节点
      for (const data of chooseRows) {
        // 校验自身是否有效
        const selfData = this.privilegeGrid.initRowData.find(p => p.uuid === data.uuid)
        if (selfData) {
          list.push(selfData)
        }
        this.getPData(selfData, list)
      }
      const rowDataUuids = this.roleGrid.rowData.map(item => item.uuid)
      list = this.removeDuplicates(list)
      // 预添加记录
      const preAddRows = list.filter(item => !rowDataUuids.includes(item.uuid))
      this.roleGrid.rowData = [...this.roleGrid.rowData, ...preAddRows]
      this.roleGrid.initRowData = [...this.roleGrid.initRowData, ...preAddRows]
      this.$nextTick(() => {
        this.recoverRoleExpandStatus()
      })
    },
    toSave() {
      if (this.toCheckForm()) {
        this.roleRequest = { ...this.roleRequest, ...this.oneRole }
        if (!this.oneRole.uuid) {
          // 新增
          if (this.oneRole.department) {
            this.roleRequest.department = this.oneRole.department
          } else {
            this.roleRequest.department = this.treeNode.uuid
          }
        }
        // privilegeGrid.initRowData
        const rowDataUuids = this.roleGrid.initRowData.map(item => item.uuid)
        this.roleRequest.removePrivilegeUuidList = this.roleGrid.oldPrivilegeUuidList.filter(item => {
          return !rowDataUuids.includes(item)
        })
        this.roleRequest.addPrivilegeUuidList = rowDataUuids.filter(item => {
          return !this.roleGrid.oldPrivilegeUuidList.includes(item)
        })
        // 循环增加的权限UUID, 判断父节点是否在这个里面，没有的话需要添加进去
        if (this.parentPrivilegeUuidMap && this.parentPrivilegeUuidMap.size > 0) {
          if (this.roleRequest.addPrivilegeUuidList && this.roleRequest.addPrivilegeUuidList.length > 0) {
            // 获取要添加的父节点
            const needAddPrivilegeUuidList = []
            for (const entry of this.parentPrivilegeUuidMap.entries()) {
              if (entry && entry.length > 1) {
                const value = entry[1]
                if (value && this.roleRequest.addPrivilegeUuidList.findIndex(p => p === value) < 0 &&
                !needAddPrivilegeUuidList.includes(value)) {
                  needAddPrivilegeUuidList.push(value)
                }
              }
            }
            if (needAddPrivilegeUuidList.length > 0) {
              this.roleRequest.addPrivilegeUuidList = this.roleRequest.addPrivilegeUuidList.concat(needAddPrivilegeUuidList)
            }
          } else { // 权限没有变更的时候，但是点击更新权限组，这个时候parentPrivilegeUuidMap有数据，那么需要把数据更新一下
            this.roleRequest.addPrivilegeUuidList = []
            for (const entry of this.parentPrivilegeUuidMap.entries()) {
              if (entry && entry.length > 1) {
                const value = entry[1]
                if (value && !this.roleRequest.addPrivilegeUuidList.includes(value)) {
                  this.roleRequest.addPrivilegeUuidList.push(value)
                }
              }
            }
          }
        }
        this.loading = getLoading()
        saveRole(this.roleRequest).then(async res => {
          this.parentPrivilegeUuidMap.clear()
          this.editHandler(false)
          this.recordRoleExpandStatus()
          await this.fetchPageData()
          this.$nextTick(() => {
            this.recoverRoleExpandStatus()
          })
          this.$emit('refreshTree', res.data.uuid)
          this.$message.success(this.$t('SystemMaintenance.SaveSuccess'))
        }).finally((e) => {
          this.loading.close()
        })
      }
    },
    toFilterNoRoleGrid() {
      if (!this.roleGridLikeName) {
        this.roleGrid.rowData = this.roleGrid.initRowData
        this.roleGrid.gridOptions.api.refreshCells({ force: true })
        return
      }
      const list = this.getFilterRole(this.roleGrid.initRowData, this.roleGridLikeName)
      const rowData = list
      for (const data of list) {
        if (data.parentUuid) {
          const parentData = this.roleGrid.initRowData.find(p => p.uuid === data.parentUuid)
          if (parentData) {
            rowData.push(parentData)
          }
        }
      }
      this.roleGrid.rowData = rowData
    },
    toFilterNoRole() {
      if (!this.privilegeLikeName) {
        this.privilegeGrid.rowData = this.privilegeGrid.initRowData
        this.privilegeGrid.gridOptions.api.refreshCells({ force: true })
        return
      }
      const list = this.getFilterRole(this.privilegeGrid.initRowData, this.privilegeLikeName)
      const rowData = list
      for (const data of list) {
        if (data.parentUuid) {
          const parentData = this.privilegeGrid.initRowData.find(p => p.uuid === data.parentUuid)
          if (parentData) {
            rowData.push(parentData)
          }
        }
      }
      this.privilegeGrid.rowData = rowData
    },
    getFilterRole(rowData, value) {
      return rowData.filter(item => {
        let result = false
        if (value && item.chineseName) {
          result = item.chineseName.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
        if (!result && value && item.category) {
          result = item.category.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
        if (!result && value && item.shape) {
          result = item.shape.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
        if (!result && value && item.point) {
          result = item.point.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
        return result
      })
    },
    async toCancelSave() {
      this.loading = getLoading()
      if (this.sourceType === this.constant.sourceType.click) {
        this.editHandler(false)
        this.recordRoleExpandStatus()
        await this.fetchPageData()
        this.$nextTick(() => {
          this.recoverRoleExpandStatus()
        })
      }
      if (this.sourceType === this.constant.sourceType.dept) {
        this.$emit('cancel')
      }
      this.loading.close()
    },
    editHandler(edit) {
      this.isEdit = edit
      this.$emit('editData', this.isEdit)
    },
    findParentPrivilege(data, list) {
      const currentUuid = data.uuid // 当前节点
      const parentUuid = data.parentUuid // 当前节点的父节点
      if (currentUuid && parentUuid) {
        // 1.先检查在当前角色下是否含有父节点
        let pData = list.find(p => p.uuid === parentUuid)
        if (!pData) {
          // 2.父节点不存在当前节点，那么就要去基础权限信息里面找，找到以后添加到Map中去
          if (this.privilegeGrid.initRowData) {
            pData = this.privilegeGrid.initRowData.find(p => p.uuid === parentUuid)
          }
          if (pData) {
            if (pData.uuid && !this.parentPrivilegeUuidMap.has(currentUuid)) {
              this.parentPrivilegeUuidMap.set(currentUuid, parentUuid)
            }
            // 检查父节点的父节点是否在当前角色下
            if (pData.parentUuid) {
              this.findParentPrivilege(pData, list)
            }
          }
        }
      }
    },

    /**
     * 获取用户
     */
    getUserListByRole() {
      getUserListByRoleUuid(this.treeNode.uuid).then(res => {
        const userList = []
        for (const data of res.data) {
          const index = userList.findIndex(p => p.uuid === data.uuid)
          if (index <= 0) {
            userList.push(data)
          }
        }
        this.userOfRoleGrid.rowData = userList
      })
    },
    /**
     * 添加用户角色
     */
    popNoCurrentRoleUser() {
      // 获取租户下全部用户
      this.userOfNoCurrentRoleGrid.isShow = true
      this.loading = getLoading()
      getUserListForRole({ pageSize: 10000 }).then(res => {
        this.userOfNoCurrentRoleGrid.rowData = res.data
        this.userOfNoCurrentRoleGrid.initRowData = res.data
      }).finally((e) => {
        this.loading.close()
      })
    },

    /**
     * 删除用户角色
     */
    async toDelUser() {
      const userUuids = await getGridSelectedIds(this.userOfRoleGrid.gridOptions, 'uuid')
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToDelete3'), this.$t('Message.ConfirmDelete'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }
      ).then(() => {
        const users = userUuids.map(uuid => {
          return { uuid }
        })
        this.loading = getLoading()
        delUser2Role({ uuid: this.treeNode.uuid, users }).then(res => {
          this.$message.success(this.$t('SystemMaintenance.DeleteSuccess'))
          this.getUserListByRole()
        }).finally((e) => {
          this.loading.close()
        })
      }).catch(() => { })
    },

    /**
     * 保存新增用户
     * @returns {Promise<void>}
     */
    async toSaveNoCurrentRoleUser() {
      // 保存没当前角色的用户 并刷新
      const userUuids = await getGridSelectedIds(this.userOfNoCurrentRoleGrid.gridOptions, 'uuid')
      for (const data of this.userOfRoleGrid.rowData) {
        if (userUuids.includes(data.uuid)) {
          this.$message.warning(this.$t('SystemMaintenance.SelectedUsersAlreadyExist'))
          return
        }
      }
      this.loading = getLoading()
      const users = userUuids.map(uuid => {
        return { uuid }
      })
      await this.toSaveUser({ uuid: this.treeNode.uuid, users }).catch(e => {
        this.loading.close()
      })
      this.loading.close()
      this.userOfNoCurrentRoleGrid.isShow = false
    },

    /**
     * 筛选用户角色
     */
    toFilterNoCurrentRoleUser() {
      this.userOfNoCurrentRoleGrid.rowData = this.getFilterUser(this.userOfNoCurrentRoleGrid.initRowData, this.userOfNoCurrentRoleGrid.searchLikeName)
      if (!this.userOfNoCurrentRoleGrid.searchLikeName) {
        this.userOfNoCurrentRoleGrid.rowData = this.userOfNoCurrentRoleGrid.initRowData
      } else {
        this.userOfNoCurrentRoleGrid.rowData = []
        for (const user of this.userOfNoCurrentRoleGrid.initRowData) {
          const chineseName = user.chineseName ? user.chineseName.toLowerCase() : ''
          const englishName = user.englishName ? user.englishName.toLowerCase() : ''
          const email = user.email ? user.email.toLowerCase() : ''
          if (chineseName.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1 || englishName.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1 || email.indexOf(this.userOfNoCurrentRoleGrid.searchLikeName) > -1) {
            this.userOfNoCurrentRoleGrid.rowData.push(user)
          }
        }
      }
    },

    toSaveUser(data, type) {
      return addUser2Role(data, type).then(res => {
        this.$message.success(this.$t('SystemMaintenance.AddSuccessfully'))
        this.getUserListByRole()
        return Promise.resolve()
      })
    },
    getFilterUser(rowData, value) {
      return rowData.filter(item => {
        if (value && item.chineseName) {
          return item.chineseName.toLowerCase().trim().includes(value.toLowerCase().trim())
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
